import {
  previousMonday,
  startOfWeek,
  previousSunday,
  startOfYesterday,
  startOfMonth,
  endOfWeek,
  format,
} from 'date-fns'
import { toast } from 'react-toastify'
import { MANAGEMENT_ERRORS_CODES } from '@/resources/enums/errors/managementErrors'

import { MANAGEMENT_PAGE as dict } from '@/resources/dict'

import { isMidnight } from '@/resources/utils/global'

const dateFormat = 'dd/MM'
const timeFormat = 'HH:mm'
const dateTimeFormat = `${dateFormat} '${dict.at}' ${timeFormat}`

export const getDefaultStartWeek = (date = new Date()) =>
  startOfWeek(date, { weekStartsOn: 1 })

export const getDefaultEndWeek = (date = new Date()) =>
  endOfWeek(date, { weekStartsOn: 1 })

const getToday = () => ({ startDate: new Date(), endDate: new Date() })

const getYesterday = () => {
  const yesterday = startOfYesterday()
  return { startDate: yesterday, endDate: yesterday }
}

const getPreviousWeek = () => {
  const startOfCurrentWeek = startOfWeek(new Date(), { weekStartsOn: 1 })
  const startOfPreviousWeek = previousMonday(startOfCurrentWeek)
  const endOfPreviousWeek = previousSunday(startOfCurrentWeek)
  return { startDate: startOfPreviousWeek, endDate: endOfPreviousWeek }
}

const getCurrentWeek = () => ({
  startDate: getDefaultStartWeek(),
  endDate: getDefaultEndWeek(),
})

const getThisMonth = () => ({
  startDate: startOfMonth(new Date()),
  endDate: new Date(),
})

export const getDateValuesByOption = {
  thisMonth: getThisMonth,
  lastWeek: getPreviousWeek,
  yesterday: getYesterday,
  currentWeek: getCurrentWeek,
  today: getToday,
}

export const getRangeDateText = (startDate, endDate) =>
  `${dict.from} ${format(startDate, dateFormat)} ${dict.until} ${format(
    endDate,
    dateFormat
  )}`

export const getRangeDateWithTimeText = (
  startDate,
  startTime,
  endDate,
  endTime
) =>
  `${dict.from} ${format(startDate, dateFormat)} às ${format(
    startTime ?? startDate,
    timeFormat
  )}h ${dict.until} ${format(endDate, dateFormat)} às ${format(
    endTime ?? endDate,
    timeFormat
  )}h`

export const getRangeDateTimeText = (startDate, endDate) =>
  `${format(startDate, dateTimeFormat)} ${dict.until} ${format(endDate, dateTimeFormat)}`

export const getFormattedDateTimeForUrl = date => {
  const formatString = 'yyyy-MM-dd--HH-mm'
  return `${format(date, formatString)}`
}

export const getParsedDateFromUrl = dateString => {
  try {
    const [date, time] = dateString.split('--')
    return new Date(`${date}T${time.replace('-', ':')}`).toISOString()
  } catch {
    return undefined
  }
}

export const areDatesEqual = (date1, date2) => {
  return format(date1, dateTimeFormat) === format(date2, dateTimeFormat)
}

export const getOneDayText = startDate => format(startDate, dateFormat)

export const getFormattedPeriod = (startDate, endDate) => ({
  startDate: format(startDate, 'yyyy-MM-dd'),
  endDate: format(endDate, 'yyyy-MM-dd'),
})

export const getDefaultStartDate = () => {
  const startDate = new Date()
  startDate.setDate(startDate.getDate() - 1)
  startDate.setHours(0, 0, 0)
  return startDate
}

export const getDefaultEndDate = () => {
  const endDate = new Date()
  endDate.setHours(23, 59, 59)
  return endDate
}

export const getCurrentDate = () => new Date()

export const defaultStartDateISO = () => getDefaultStartDate().toISOString()

export const defaultEndDateISO = () => getCurrentDate().toISOString()

export const handleTheEndDate = endDate => {
  if (isMidnight(endDate)) {
    endDate.setHours(23, 59, 59)
  }
  return endDate || null
}

export const formatDate = date => {
  if (date) {
    const hours = `${date.getHours()}`.padStart(2, '0')
    const minutes = `${date.getMinutes()}`.padStart(2, '0')
    const day = `${date.getDate()}`.padStart(2, '0')
    const month = `${date.getMonth() + 1}`.padStart(2, '0')
    const year = date.getFullYear()

    const time = `${hours}:${minutes}`
    const formattedDate = `${day}/${month}/${year}`

    return `${formattedDate} às ${time}`
  }
  return null
}

export const handleReportError = errorCode => {
  if (!errorCode) return

  if (errorCode === MANAGEMENT_ERRORS_CODES.BUSS_0022)
    return toast.error(dict.noDataForPeriod)

  if (errorCode === MANAGEMENT_ERRORS_CODES.VAL_0002)
    return toast.error(dict.cashBalanceCard.errorRangeDate)

  return toast.error(dict.defaultRequestErrorMessage)
}
